/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { StoreManagementPreviewItemResponse } from './StoreManagementPreviewItemResponse';

export type StoreManagementPreviewItemResponseApiRespoonse = {
    data?: StoreManagementPreviewItemResponse;
    status?: StoreManagementPreviewItemResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace StoreManagementPreviewItemResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

